export const TOKEN_KEY = `__jwtToken__`;
export const CONFIRMATION_TOKEN_KEY = `__jwtConfirmationToken__`;
export const TOKEN_KEY_NEW_PASS = `__jwtTokenNewPass__`;
export const REDIRECT_PATH = '/';
export const IP_CACHE_KEY = 'user_ip';
export const IP_CACHE_TIMESTAMP_KEY = 'user_ip_timestamp';
export const IP_CACHE_DURATION = 60 * 60 * 1000;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const API_BASE_URL = process.env.REACT_APP_ENDPOINT;
export const API_IP = process.env.API_IP;
export const API_CURRENCY = process.env.REACT_APP_CURRENCY_API;
export const DATE_FORMAT = 'DD.MM.YYYY HH:mm';
